module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIRJREFUeNrs1sEJwkAQQNFd04ClpANLMaVpJSYdpBQ70Dl4yDFEXHD2PZhbYPjsBrYUAKAMDXa8YmrM/MslpywnIqTHkDXmkiHk6WoJESJEiBAhjdQd30wx1y92jJunylH3mFsXJ9LC4zP+ESFChAgRIiRLyDlDyLJ5OLpaQgCAP/QWYACCZwl9GdK2YwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/more.png
// module id = MprZ
// module chunks = 1